export default __webpack_public_path__ + "static/media/Button.0bd77d40.png";